<template>
  <div
    class="column medium-8 small-12"
    v-bind:class="{
      'text-center': voucherStatus != 0,
      'medium-offset-2': voucherStatus != 0,
    }"
    v-html="finish"
  ></div>
</template>

<script>
import api from '../apiAccess.js'

export default {
  name: 'Finish',
  props: ['translations'],
  data() {
    return {
      get msisdn() {
        return localStorage.getItem('msisdn') || '';
      },
      amount: '',
      value: '',
      code: '',
      invoice: '',
      get voucherId() {
        return localStorage.getItem('voucherId') || 0;
      },
      get token() {
        return localStorage.getItem('token') || '';
      },
      voucherStatus: -1,
    }
  },
  computed: {
    finish: function () {
      if (this.voucherStatus == -1) {
        const likeEmoji = `
        <p>
          <div class="emoji emoji-like">
              <div class="emoji-hand">
                <div class="emoji-thumb"></div>
            </div>
          </div>
        </p>`
        return this.translations.finishLoading1 + likeEmoji + this.translations.finishLoading2
      }

      if (this.voucherStatus > 0) {
        const sadEmoji = `
        <p>
          <div class="emoji emoji-sad">
            <div class="emoji-face">
              <div class="emoji-eyebrows"></div><div class="emoji-eyes"></div><div class="emoji-mouth"></div>
            </div>
          </div>
        </p>`
        return this.translations.finishError1 + sadEmoji + this.translations.finishError2
      }

      return this.translations.finish1 + this.amount +
        this.translations.finish2 + this.msisdn +
        this.translations.finish3 + this.code +
        this.translations.finish4 + this.code +
        this.translations.finish5 + this.code +
        this.translations.finish6 + this.invoice +
        this.translations.finish7;
    }
  },
  methods: {
    getVoucher(repeatUntil) {
      if (Date.now() > repeatUntil) {
        this.voucherStatus = 1
        return
      }

      api.getFinalVoucher(this.voucherId, this.token)
        .then(r => {
          if (r && r.response != null && r.response.code != null) {
            this.voucherStatus = 0
            this.code = r.response.code
            this.amount = r.response.amount
            this.invoice = r.response.invoice
            this.$emit('error', r.response)
          } else {
            throw new Error("Voucher not ready")
          }
        })
        .catch(e => {
          this.$emit('error', e)

          setTimeout(() => this.getVoucher(repeatUntil), 3000)
        })
    }
  },
  mounted() {
    this.getVoucher(Date.now() + 60 * 1000);

    //console.log(this.voucherId)
    //console.log(this.token)
  }
}
</script>







// WEBPACK FOOTER //
// src/components/Finish.vue